import { Component, AfterViewInit } from '@angular/core';
import { GoogleChartsModule, GoogleChartComponent } from 'angular-google-charts';

@Component({
  selector: 'app-device-connectivity-status',
  templateUrl: './device-connectivity-status.component.html',
  styleUrls: ['./device-connectivity-status.component.css']
})
export class DeviceConnectivityStatusComponent implements AfterViewInit {

  constructor() {
    GoogleChartsModule.forRoot(); // Initialize the Google Charts module
  }

  ngAfterViewInit() {
    // Wait for the view to be initialized before calling Google Charts API
    google.charts.load('current', {
      'packages': ['geochart'],
      'mapsApiKey': 'YOUR_API_KEY' // Replace with your actual API key
    });

    google.charts.setOnLoadCallback(this.drawRegionsMap.bind(this));
  }

  drawRegionsMap() {
    var data = new google.visualization.DataTable();
    data.addColumn('string', 'Country');
    data.addColumn('number', 'Popularity');
    data.addRows([
      ['Germany', 200],
      ['United States', 300],
      ['Brazil', 400],
      ['Canada', 500],
      ['France', 600],
      ['RU', 700]
    ]);

    var options = {};

    var chartElement = document.getElementById('regions_div');
    if (chartElement instanceof Element) {
      var chart = new google.visualization.GeoChart(chartElement);
      chart.draw(data, options);
    }
  }
}
